// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/bid_limit_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { BidLimitService } from "./bid_limit_service_pb";

/**
 * GetBidLimitMatrixScreen returns all three matrix tabs' worth of
 * bid-limit state in one read (= AdminBidLimits screen aggregation).
 * Read-only BFF aggregation: fans out to backend
 * BidLimitService.GetBidLimitMatrix for SPOT_NORMAL, SPOT_BLOCK, INTRADAY.
 *
 * @generated from rpc bffuser.v1.BidLimitService.GetBidLimitMatrixScreen
 */
export const getBidLimitMatrixScreen = BidLimitService.method.getBidLimitMatrixScreen;

/**
 * GetBidLimitMatrix returns one tab's worth of bid-limit state for the
 * given bid_segment (cells + segment_meta, plus market_order_policy
 * for SPOT_NORMAL/INTRADAY or block_mandatory_policy for SPOT_BLOCK).
 *
 * @generated from rpc bffuser.v1.BidLimitService.GetBidLimitMatrix
 */
export const getBidLimitMatrix = BidLimitService.method.getBidLimitMatrix;

/**
 * UpdateBidLimitMatrix replaces all cells of a single bid_segment
 * for the organization, using bid_limit_segment_meta.updated_at as
 * the optimistic-lock baseline.
 *
 * @generated from rpc bffuser.v1.BidLimitService.UpdateBidLimitMatrix
 */
export const updateBidLimitMatrix = BidLimitService.method.updateBidLimitMatrix;

/**
 * UpdateMarketOrderPolicy toggles the market-order allow flag for a
 * single (bid_segment, area_code) pair.
 *
 * @generated from rpc bffuser.v1.BidLimitService.UpdateMarketOrderPolicy
 */
export const updateMarketOrderPolicy = BidLimitService.method.updateMarketOrderPolicy;

/**
 * UpdateBlockMandatoryPolicy toggles the organization-wide block-
 * mandatory flag.
 *
 * @generated from rpc bffuser.v1.BidLimitService.UpdateBlockMandatoryPolicy
 */
export const updateBlockMandatoryPolicy = BidLimitService.method.updateBlockMandatoryPolicy;

/**
 * UpdateFeeAutoConsiderPolicy toggles the "手数料自動考慮" flag for a
 * single bid_segment (SPOT_NORMAL / INTRADAY, independent per segment).
 *
 * @generated from rpc bffuser.v1.BidLimitService.UpdateFeeAutoConsiderPolicy
 */
export const updateFeeAutoConsiderPolicy = BidLimitService.method.updateFeeAutoConsiderPolicy;

/**
 * UpdateDefaultWithdrawOffset replaces the organization-wide default
 * withdraw offset for intraday bids (bidding/bid-limits.md §4,
 * AC-BDL-501/502/503).
 *
 * @generated from rpc bffuser.v1.BidLimitService.UpdateDefaultWithdrawOffset
 */
export const updateDefaultWithdrawOffset = BidLimitService.method.updateDefaultWithdrawOffset;

/**
 * ListBidTags returns every bid tag for the organization.
 *
 * @generated from rpc bffuser.v1.BidLimitService.ListBidTags
 */
export const listBidTags = BidLimitService.method.listBidTags;

/**
 * CreateBidTag creates a new bid tag.
 *
 * @generated from rpc bffuser.v1.BidLimitService.CreateBidTag
 */
export const createBidTag = BidLimitService.method.createBidTag;

/**
 * UpdateBidTag performs a full replacement (PUT semantics) of the
 * bid tag. Uses optimistic locking via expected_updated_at.
 *
 * @generated from rpc bffuser.v1.BidLimitService.UpdateBidTag
 */
export const updateBidTag = BidLimitService.method.updateBidTag;

/**
 * DeleteBidTag deletes the bid tag. Uses optimistic locking via
 * expected_updated_at.
 *
 * @generated from rpc bffuser.v1.BidLimitService.DeleteBidTag
 */
export const deleteBidTag = BidLimitService.method.deleteBidTag;
